import { licence } from '@seek/ca-myprofile-utils';
import gql from 'graphql-tag';

export const getLicences = gql`
  query GetLicences($languageCode: LanguageCodeIso!, $zone: Zone!) {
    viewer {
      _id
      licences(
        languageCode: $languageCode
        zone: $zone
        platform: WEB
        source: PROFILE
      ) {
        ...licence
      }
    }
  }
  ${licence}
`;

export const deleteLicence = gql`
  mutation DeleteLicence(
    $deleteLicenceInput: DeleteLicenceInput!
    $languageCode: LanguageCodeIso!
    $zone: Zone!
  ) {
    deleteLicence(input: $deleteLicenceInput) {
      viewer {
        _id
        licences(
          languageCode: $languageCode
          zone: $zone
          platform: WEB
          source: PROFILE
        ) {
          ...licence
        }
      }
    }
  }
  ${licence}
`;

export const updateLicence = gql`
  mutation UpdateLicence(
    $licenceData: UpdateLicenceInput!
    $languageCode: LanguageCodeIso!
    $zone: Zone!
  ) {
    updateLicence(input: $licenceData) {
      viewer {
        _id
        licences(
          languageCode: $languageCode
          zone: $zone
          platform: WEB
          source: PROFILE
        ) {
          ...licence
        }
      }
    }
  }
  ${licence}
`;

export const updateVerifiedLicence = gql`
  mutation UpdateVerifiedLicence(
    $verifiedLicenceData: UpdateVerifiedLicenceInput!
  ) {
    updateVerifiedLicence(input: $verifiedLicenceData) {
      id
      description
    }
  }
`;
